var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSkipped(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 38,
    height: 38,
    rx: 6,
    fill: "#FFA443"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6633 11.4111C19.9888 11.0856 20.5164 11.0856 20.8419 11.4111L23.3419 13.9111C23.6673 14.2365 23.6673 14.7641 23.3419 15.0896L20.8419 17.5896C20.5164 17.915 19.9888 17.915 19.6633 17.5896C19.3379 17.2641 19.3379 16.7365 19.6633 16.4111L20.7408 15.3337H19.4193C16.4628 15.3337 14.0026 17.7939 14.0026 20.7503C14.0026 23.7068 16.4628 26.167 19.4193 26.167C22.3757 26.167 24.8359 23.7068 24.8359 20.7503C24.8359 20.2901 25.209 19.917 25.6693 19.917C26.1295 19.917 26.5026 20.2901 26.5026 20.7503C26.5026 24.6272 23.2962 27.8337 19.4193 27.8337C15.5424 27.8337 12.3359 24.6272 12.3359 20.7503C12.3359 16.8734 15.5424 13.667 19.4193 13.667H20.7408L19.6633 12.5896C19.3379 12.2641 19.3379 11.7365 19.6633 11.4111Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkipped);
export default __webpack_public_path__ + "static/media/skipped.1358447744b39da9630851ce988b8cd9.svg";
export { ForwardRef as ReactComponent };